<template>
  
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="section-title">
                    <h2 class="title">{{categName}}</h2>
                </div>
            </div>
            
            <div class="col-md-6 col-sm-6" v-for="obj in news.slice(0,2)" :key="obj.key">
                <article class="article">
                    <div class="article-img">
                        <carousel :per-page="1" :autoplay="true"  :loop="true" :paginationEnabled="false">
                            <slide v-for="(image,index) in obj.images" :key="index">
                                <router-link :to="'/single-post/'+obj.id">
                                    <img height="200" :src="$urlpath+image" alt="">
                                </router-link>
                                <ul class="article-info">
                                    <li class="article-type"><fa :icon="['fas', 'camera']" /></li>
                                </ul>
                            </slide>
                        </carousel>
                    </div>
                    <div class="article-body">
                        <h3 class="article-title"><router-link :to="'/single-post/'+obj.id">{{obj.title|truncate(40)}}</router-link></h3>
                        <ul class="article-meta">
                            <li><fa :icon="['far', 'clock']" /> {{obj.postdate|calendar}}</li>
                        </ul>
                        <p class="text-justify" v-snip:js="4"  v-html="obj.content"></p>
                    </div>
                </article>
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-4 col-sm-4" v-for="obj in news.slice(2,5)" :key="obj.key">
                <article class="article">
                    <div class="article-img">
                        <carousel :per-page="1" :autoplay="true"  :loop="true" :paginationEnabled="false">
                            <slide v-for="(image,index) in obj.images" :key="index">
                                <router-link :to="'/single-post/'+obj.id">
                                    <img height="200" :src="$urlpath+image" alt="">
                                </router-link>
                                <ul class="article-info">
                                    <li class="article-type"><fa :icon="['fas', 'camera']" /></li>
                                </ul>
                            </slide>
                        </carousel>
                    </div>
                    <div class="article-body">
                        <h4 class="article-title"><router-link :to="'/single-post/'+obj.id">{{obj.title|truncate(40)}}</router-link></h4>
                        <ul class="article-meta">
                            <li><fa :icon="['far', 'clock']" /> {{obj.postdate|calendar}}</li>
                        </ul>
                    </div>
                </article>
            </div>
            
        </div>
    </div>
    
 
</template>

<script>
import Mainaxios from '../Api'
export default {
  name: "SideComponent",
  props: {
    categID: Number,
    categName: String,
  },
  data(){
        return{
            news:[],
            marquees:[],
            paused:false,
            
        }
    },
    mounted(){
        this.fetchData();
    },
    methods:{
        async fetchData(){
			await Mainaxios.get("api/categNews/"+this.categID).then(({data}) => (this.news = data));
        },
       
        
    },
    created(){

    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>